const services = [
  {
    slug: "umzug",
    to: "/umzug",
    icon: "fa-truck-moving",
    title: "Umzug",
    short: "Privat- und Firmenumzüge in Zürich und der ganzen Schweiz.",
    tags: ["Privat", "Firma", "Schweizweit"],
  },
  {
    slug: "reinigung",
    to: "/reinigung",
    icon: "fa-broom",
    title: "Reinigung",
    short: "Endreinigung mit Abnahmegarantie, Unterhalt und Fensterreinigung.",
    tags: ["Abnahmegarantie", "Büro", "Fenster"],
  },
  {
    slug: "montage",
    to: "/montage",
    icon: "fa-screwdriver-wrench",
    title: "Montage",
    short: "Möbelmontage, Küchen, Bilder und Regale – sauber und präzise.",
    tags: ["Möbel", "Küche", "Aufbau"],
  },
  {
    slug: "transport",
    to: "/logistik",
    icon: "fa-boxes",
    title: "Transport",
    short: "Transporte, Lieferungen und Kurierdienst in der ganzen Schweiz.",
    tags: ["Transport", "Kurier", "Lieferung"],
  },
  {
    slug: "entsorgung",
    to: "/logistik",
    icon: "fa-recycle",
    title: "Entsorgung",
    short: "Fachgerechte Entsorgung, Recycling und Räumungen.",
    tags: ["Entsorgung", "Recycling", "Räumung"],
  },
  {
    slug: "hauswartung",
    to: "/logistik",
    icon: "fa-house-chimney-user",
    title: "Hauswartung",
    short: "Regelmässige Hauswartung für Liegenschaften und Büros.",
    tags: ["Hauswartung", "Liegenschaft", "Büro"],
  },
];

export default services;